module.exports = __webpack_public_path__ + "static/media/Streamlining-Sustainability.c04e63ea.jpg";